export const GET_ORGANIZATION_REQUEST = '@@organization/GET_ORGANIZATION_REQUEST'
export const GET_ORGANIZATION_REQUEST_SUCCESS = '@@organization/GET_ORGANIZATION_REQUEST_SUCCESS'